module.exports = __webpack_public_path__ + "static/media/startups.38dfae7b.png";